import {useState, useMemo, useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {useSiteState} from 'hooks/useSiteInfo/SiteStateProvider';
import {Site} from 'hooks/useSiteInfo/interfaces/Site';

function useQuery() {
  const {search} = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

export default function useSiteSelection() {
  let query = useQuery();

  //#region State
  const [siteSelected, setSiteSelected] = useState<Site | undefined>();
  const [queryErrors, setQueryErrors] = useState<string[]>([]);
  //#endregion State

  //#region Context
  const {
    state: {isSiteStateReady, sites},
  } = useSiteState();

  //#endregion Context
  useEffect(() => {
    const siteIdQuery: string[] = query.getAll('siteId');
    if (!isSiteStateReady) {
      setSiteSelected(undefined);
      setQueryErrors(['Site Info Not Loaded']);
      return;
    }

    if (siteIdQuery.length !== 1) {
      setSiteSelected(undefined);
      setQueryErrors(['Multiple SiteIds Selected']);
      return;
    }

    const matchingSiteId: Site[] = sites.filter(site => site.siteId === siteIdQuery[0]);
    if (matchingSiteId.length === 1) {
      setSiteSelected(matchingSiteId[0]);
    }
  }, [query, isSiteStateReady, sites]);

  return {siteSelected, queryErrors};
}
